<template>
  <div>
    <WidgetCircularDiagram
        v-if="circular"
        :items="items.length === 0 ? noData : items"
        :large-data="largeData"
        :show-percent="showPercent"
        :compact="compact"
    />
    <WidgetHorizontalDiagram v-else :items="items.length === 0 ? noData : items" />
  </div>
</template>

<script>
import WidgetHorizontalDiagram from "./WidgetHorizontalDiagram";
import WidgetCircularDiagram from "./WidgetCircularDiagram";
export default {
  name: "BaseWidget",
  components: {WidgetCircularDiagram, WidgetHorizontalDiagram},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    circular: {
      type: Boolean,
      default: false,
    },
    largeData: Boolean,
    showPercent: {
      type: Boolean,
      default: true,
    },
    compact: Boolean,
  },
  computed: {
    noData() {
      return [{
        name: this.localStorage.translations.pages.common.text['net-dannyh'],
        color: '#d1d1d1',
        count: 1
      }]
    }
  }
}
</script>
